import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { Button, Modal, ProgressBar, Spinner } from "react-bootstrap";
import { CSVLink } from "react-csv";
import { saveAs } from "file-saver";


const ProductDetailsExportModal = ({
  preheader = [],
  onShow,
  handleClose,
  exportProduct,
  title,
}) => {
  const [exportCSV, setExportCSV] = useState([]);
  const [dataReady, setDataReady] = useState(false);
  const [current, setCurrent] = useState(0);

  let csvData = [];
  let x = 0;

  const processCSV = async (exportProduct) => {
    exportProduct?.map((item) => {
      x++;
      csvData = [
        ...csvData,
        {
          _id: item?._id,
          name: item?.name,
          article_code: item?.article_code,
          unit: item?.unit,
          categoryId: item?.category?._id
            ? item?.category?._id
            : "No Category Found",
          categoryName: item?.category?.name
            ? item?.category?.name
            : "No Category Found",
          categoryCode: item?.category?.code
            ? item?.category?.code
            : "No Category Found",
          categoryMcId: item?.category?.mcId
            ? item?.category?.mcId
            : "No Master Category Found",
          categoryGroup: item?.category?.group
            ? item?.category?.group
            : "No Group Found",
        },
      ];
    });

    setCurrent(x);
    setDataReady(true);
    setExportCSV(csvData);
  };

  useEffect(() => {
    if (exportProduct?.length > 0) {
      processCSV(exportProduct);
    }
  }, [exportProduct]);

  const headers = [
    { label: "ID", key: "_id" },
    { label: "Name", key: "name" },
    { label: "Article Code", key: "article_code" },
    { label: "Category ID", key: "categoryId" },
    { label: "Category Name", key: "categoryName" },
    { label: "Category Code", key: "categoryCode" },
    { label: "Category MC ID", key: "categoryMcId" },
    { label: "Category Group", key: "categoryGroup" },
  ];

  const convertArrayOfObjectsToCSV = (array, preheader) => {
    if (!array || !array.length) return null;

    const headers = Object.keys(array[0]);
    const csvData = [
      ...preheader.map((row) => row.join(",")), // Add preheader rows
      headers.join(","), // Add header row
      ...array.map((row) =>
        headers
          .map((fieldName) => JSON.stringify(row[fieldName]) || "")
          .join(",")
      ),
    ];

    return csvData.join("\r\n");
  };

  const downloadCSV = () => {
    const csvString = convertArrayOfObjectsToCSV(exportCSV, preheader);
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const today = new Date();
    saveAs(blob, `Product Details Export - [${today.toDateString()}].csv`);
  };

  return (
    <Modal show={onShow} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Export Product Details</Modal.Title>
      </Modal.Header>

      <Modal.Body className="text-center">
        {dataReady === false ? (
          <div className="d-flex flex-column align-items-center">
            <Spinner animation="grow" variant="warning" size="sm" />
            <Icons.ClockOutline className="icon-trash text-warning" size={80} />
            <p className="text-dark mt-3 mb-3">
              <small>Please wait while your export is getting ready!</small>
            </p>
            <ProgressBar
              className="w-100"
              striped
              variant="success"
              now={
                current > 0
                  ? exportProduct?.length > 0
                    ? Math.fround(
                        (100 / exportProduct?.length) * current
                      )?.toFixed(2)
                    : 0
                  : 0
              }
              label={`${
                current > 0
                  ? exportProduct?.length > 0
                    ? Math.fround(
                        (100 / exportProduct?.length) * current
                      )?.toFixed(2)
                    : 0
                  : 0
              }%  - ${current} of ${exportProduct?.length}`}
            />
          </div>
        ) : (
          <div className="d-flex flex-column align-items-center">
            <Icons.CheckCircleOutline
              className="icon-trash text-success"
              size={100}
            />
            <p className="text-dark my-3">Your export is ready!</p>
            <Button
              className="btn btn-dark"
              onClick={downloadCSV} // Trigger the downloadCSV function
            >
              <Icons.DownloadOutline
                className="icon-trash text-warning"
                size={22}
              />{" "}
              Download Product Data
            </Button>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProductDetailsExportModal;
